import { CreateButton } from "react-admin";
import TreeNodeCreate from "./TreeNodeCreate";
import TreeNodeEdit from "./TreeNodeEdit";
import { DeleteMenuItemWithConfirmation, NodeActions, TreeWithDetails } from "@react-admin/ra-tree";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";

const TreeList = () => {
  return (
    <TreeWithDetails
      sx={{
        display: "flex",
        flexWrap: "wrap",
        "& .RaTreeWithDetails-cardTree": {
          minWidth: "fit-content",
        },
        "& .RaTreeWithDetails-actionCard": {
          width: "initial",
          flexGrow: 1,
        },
        "& .MuiPaper-root": {
          width: "fit-content",
        },
      }}
      draggable
      showLine
      nodeActions={
        <SecuredComponent permission={permissions.canChangeTreeStructure}>
          <NodeActions>
            <DeleteMenuItemWithConfirmation />
          </NodeActions>
        </SecuredComponent>
      }
      create={
        <SecuredComponent permission={permissions.canChangeTreeStructure}>
          <TreeNodeCreate />
        </SecuredComponent>
      }
      edit={
        <SecuredComponent permission={permissions.canChangeTreeStructure}>
          <TreeNodeEdit />
        </SecuredComponent>
      }
      addRootButton={
        <SecuredComponent permission={permissions.canChangeTreeStructure}>
          <CreateButton />
        </SecuredComponent>
      }
    />
  );
};

export default TreeList;
